module.exports = __webpack_public_path__ + "static/media/Samuel J. Tilden - 1876.04073581.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Samuel J. Tilden - 1876.jpg
// module id = 547
// module chunks = 0